import { IDropDownItem } from 'core/interface/dropDown';

export const contractTypes: IDropDownItem[] = [
  { value: 1, to_show: 'Permanent' },
  { value: 2, to_show: 'Freelance' },
  { value: 3, to_show: 'Internship' }
];
